// api.js

import axios from 'axios';

// Use env-configured API base URL from .env files (no implicit overrides)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL);

api.interceptors.request.use((config) => {
  if (!config.auth) {
    const token = localStorage.getItem('token');
    config.headers.Authorization = token ? `Bearer ${token}` : '';
  }
  return config;
});




api.interceptors.response.use(
  response => response,
  error => {
    console.log('API request error:', error); // Debugging line
    return Promise.reject(error);
  }
);


export default api;

